import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-BiKz7_SZ.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const LocationFilledSize32Component = (props, ref) => (jsx("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("g", { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.3024 4.9514L7.29437 9.24055C3.26442 10.9677 1.24944 11.8312 1.33599 13.1417C1.42253 14.4522 3.53356 15.0433 7.75563 16.2255L14.0203 17.9796L15.7745 24.2443C16.9566 28.4664 17.5477 30.5774 18.8582 30.664C20.1687 30.7505 21.0323 28.7355 22.7594 24.7056L27.0486 14.6976C30.145 7.47266 31.6932 3.8602 29.9165 2.0835C28.1398 0.306805 24.5273 1.855 17.3024 4.9514Z", fill: "var(--magritte-ui-icon-color)" }) }) }));
const LocationFilledSize32 = hoc(forwardRef(LocationFilledSize32Component), 'LocationFilledSize32');

export { LocationFilledSize32 as default };
//# sourceMappingURL=LocationFilledSize32.js.map
